import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { usePathname } from 'src/routes/hooks';

import Iconify from 'src/components/iconify';

import { getMenuIconTheme } from './menuIconTheme';

// ----------------------------------------------------------------------

export default function NavMenuIcon({
  src,
  href,
  itemId,
  title,
  selected: selectedProp,
  size = 32,
}) {
  const pathname = usePathname();
  const theme = getMenuIconTheme({ itemId, src, title });
  const selected =
    selectedProp ??
    (href ? pathname === href || pathname.startsWith(`${href}/`) : false);
  const iconSize = Math.round(size * 0.46);

  return (
    <Box
      className="nav-menu-icon"
      sx={{
        width: size,
        height: size,
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        bgcolor: selected ? theme.color : theme.bg,
        color: selected ? '#fff' : theme.color,
        transition: 'all 0.2s ease',
        boxShadow: selected ? `0 6px 16px ${theme.color}33` : '0 1px 3px rgba(15,23,42,0.06)',
        '.MuiListItemButton-root:hover &': {
          transform: 'scale(1.04)',
        },
      }}
    >
      <Iconify icon={theme.icon} width={iconSize} />
    </Box>
  );
}

NavMenuIcon.propTypes = {
  src: PropTypes.string,
  href: PropTypes.string,
  itemId: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.number,
};
